// extracted by mini-css-extract-plugin
export default {"previewTable":"ReportMensualPreview_previewTable__vdeoq"};